<div mat-dialog-content>
	<div [innerHTML]="content | safeHtml"></div>
</div>
